import React from "react";
import { useTranslation } from "react-i18next";

import banner1 from "../../img/Support/banner-1.webp";
import banner2 from "../../img/Support/banner-2.webp";
import Fade from 'react-reveal/Fade';

function Banner() {
  const { t } = useTranslation();

  return (
    <section className="mt-[60px] xl:mt-[0px]">
      {/* Desktop */}
      <div className="hidden xl:block pt-[122px] mx-auto max-w-[1220px]">
        {/* Row 1: text left, image right */}
        <Fade bottom>
        <div className="flex h-[288px] overflow-hidden">
          <div className="flex w-[625px] shrink-0 flex-col justify-center pr-[50px]">
            <h1 className="font-['Nunito_Sans'] text-[32px] font-black leading-[1.5] text-[#3273b4]">
              {t("support.banner.title1")}
            </h1>
            <p className="mt-[20px] font-['Nunito_Sans'] text-[16px] font-light leading-[1.5] text-[#05193a]">
              {t("support.banner.text1")}
            </p>
          </div>
          <div className="flex-1 overflow-hidden">
            <img src={banner1} alt="" className="h-full w-full object-cover" />
          </div>
        </div>

        </Fade>

        {/* Row 2: image left, text right */}
        <Fade bottom delay={200}>
        <div className="flex h-[296px] overflow-hidden">
          <div className="w-[625px] shrink-0 overflow-hidden">
            <img src={banner2} alt="" className="h-full w-full object-cover" />
          </div>
          <div className="flex flex-1 flex-col justify-center pl-[50px]">
            <h2 className="font-['Nunito_Sans'] text-[32px] font-black leading-[1.5] text-[#3273b4]">
              {t("support.banner.title2")}
            </h2>
            <p className="mt-[20px] font-['Nunito_Sans'] text-[16px] font-light leading-[1.5] text-[#05193a]">
              {t("support.banner.text2")}
            </p>
          </div>
        </div>
        </Fade>
      </div>

      {/* Mobile */}
      <div className="xl:hidden">
        <Fade bottom>
        <div className="">
          <div className="h-[165px] overflow-hidden">
            <img src={banner1} alt="" className="h-full w-full object-cover" />
          </div>

          <div className="px-[20px] pt-[25px]">
            <h1 className="font-['Nunito_Sans'] text-[26px] font-black leading-[1.5] text-[#3273b4]">
              {t("support.banner.title1")}
            </h1>
            <p className="mt-[15px] font-['Nunito_Sans'] text-[14px] font-light leading-[1.5] text-[#05193a]">
              {t("support.banner.text1")}
            </p>
          </div>
        </div>
        </Fade>

        <Fade bottom delay={200}>
        <div className="mt-[80px]">
          <div className="h-[165px] overflow-hidden">
            <img src={banner2} alt="" className="h-full w-full object-cover" />
          </div>
          <div className="px-[20px] pt-[25px]">
            <h1 className="font-['Nunito_Sans'] text-[26px] font-black leading-[1.5] text-[#3273b4]">
              {t("support.banner.title2")}
            </h1>
            <p className="mt-[15px] font-['Nunito_Sans'] text-[14px] font-light leading-[1.5] text-[#05193a]">
              {t("support.banner.text2")}
            </p>
          </div>

        </div>
        </Fade>
      </div>
    </section>
  );
}

export default Banner;
